const AUTH_VERSION = 'v1';
const API_VERSION = 'v1';

export const API_BASE_URL = `https://api.totoopen.by/public/api/${API_VERSION}/toto_is`;
export const AUTH_BASE_URL = `https://auth.totoopen.by/public/api/${AUTH_VERSION}/toto_is`;
export const ORIGIN = 'http://localhost:3000';
export const ENV = 'prod';
